module.exports = "<svg id=\"99311ef4-1d5e-4516-b9ee-cccb1b67893c\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>LeftCarot</title><path d=\"M36.21,45,22.78,28.22h.1l-2.34-2.86,2.3-2.85h-.07L36.21,5.74a3,3,0,0,0-.45-4,2.87,2.87,0,0,0-4,.45L14.62,23.58A2.61,2.61,0,0,0,14,25.36h0a4.21,4.21,0,0,0,.62,1.78l17.12,21.4a2.87,2.87,0,0,0,4,.45A3,3,0,0,0,36.21,45Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/LeftCarot.svg
// module id = 518
// module chunks = 1